import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // Import global styles and Tailwind
import { AuthProvider } from './contexts/AuthContext';
import { SystemProvider } from './contexts/SystemContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <SystemProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </SystemProvider>
  </React.StrictMode>
);